
export type PlatformType = "BROWSER" | "MOBILE"

var platformType: PlatformType = "BROWSER";

export function setPlatformType(value: PlatformType) {
    platformType = value;
}

export function getPlatformType(): PlatformType {
    return platformType;
}